export default "__VITE_ASSET__d823bc6c__"